import React from "react";

export default function UploadFileModal({
  handleSubmit,
  handleClose,
  setFile,
  name,
  fileExtensions = null,
}) {
  return (
    <>
      <div className="justify-center relative flex mx-auto overflow-x-auto overflow-y-auto inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 max-w-3xl justify-center">
          {/*content*/}
          <form onSubmit={handleSubmit}>
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              {/*header*/}
              <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                <h3 className="text-3xl font-semibold">Upload File</h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={() => handleClose()}
                >
                  <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
              </div>
              {/*body*/}
              <div className="relative left-2 p-6 flex-auto ">
                <div className="px-4 py-6">
                  <label className="font-semibold mb-2 pb-2">
                    Upload File ({fileExtensions}){" "}
                  </label>
                  <br />
                  <br />
                  <input
                    type="file"
                    className="px-4"
                    name={name}
                    onChange={(e) => setFile(name, e.target.files[0])}
                  />
                </div>
                {/* <p className="my-4 text-blueGray-500 text-lg leading-relaxed">
                {message ? message : "Anda yakin akan menghapus data tersebut?"}
              </p> */}
              </div>
              {/*footer*/}
              <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-2 mt-2 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => handleClose()}
                >
                  Close
                </button>
                <button
                  className="bg-orange-500 text-white active:bg-orange-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-2 mt-2 ease-linear transition-all duration-150"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
}
